import React from 'react';

const TennisSvg = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 57.549 57.549"
    xmlSpace="preserve"
    width={size}
    height={size}
    fill={color}
    {...props}
  >
    <g>
      <circle cx="32.734" cy="13.533" r="5.021" />
      <path d="M45.398,10.474c0.04-2.682-4.115-2.678-4.154,0c-0.037,2.37-0.652,7.533-3.209,8.972
        c-2.267-0.901-4.728,0.627-5.402,2.624c-0.035,0.058-0.076,0.104-0.109,0.168c-0.657,1.244-1.482,2.264-2.443,3.198
        c-1.064-1.001-1.947-2.229-2.951-3.271c-0.781-0.812-1.75-0.758-2.475-0.287l-4.211-4.538c1.574-1.904,1.015-5.333-1.373-7.908
        c-2.536-2.732-6.189-3.482-8.142-1.67c-1.952,1.812-1.477,5.511,1.058,8.243c2.391,2.574,5.767,3.387,7.783,1.958l4.224,4.551
        c-0.512,0.737-0.605,1.756,0.197,2.588c1.616,1.676,2.953,3.529,4.923,4.827c0.833,0.548,1.816,0.248,2.52-0.325
        c1.08-0.879,2.057-1.83,2.906-2.888c1.414,2.475,1.295,7.13,1.076,9.702c-0.033,0.396-0.011,0.76,0.051,1.097
        c-1.205,2.999-1.076,6.186-3.213,8.788c-1.285,1.568-2.732,3.025-4.194,4.432c-1.934,1.863,1.009,4.797,2.938,2.938
        c1.613-1.553,3.167-3.176,4.587-4.909c2.142-2.611,2.431-5.58,3.343-8.572c0.269,0.005,0.541-0.013,0.809-0.056
        c0.64,4.953,0.673,9.824-1.958,14.311c-1.356,2.317,2.235,4.408,3.59,2.098c3.763-6.42,3.087-13.353,1.94-20.475
        c-0.012-0.072-0.036-0.135-0.055-0.203c0.28-4.16-0.072-9.783-2.436-13.557C44.182,19.66,45.339,14.416,45.398,10.474z
         M12.344,15.67c-2.352-2.535-2.839-5.922-1.084-7.551s5.097-0.891,7.45,1.644c2.351,2.536,2.838,5.923,1.085,7.552
        C18.04,18.945,14.698,18.207,12.344,15.67z" />
      <circle cx="45.962" cy="1.86" r="1.86" />
    </g>
  </svg>
);

export default TennisSvg;
